<template>
  <div class="quantity-wrap">
    <div class="UiQuantity shopUiQuantity">
      <a
        class="UiQuantity__btn UiQuantity__btn--minus shopUiQuantity__btn"
        @click.prevent="reduceCount"
      >
        –
      </a>
      <input class="UiQuantity__text shopUiQuantity__text" type="text" :value="counter" readonly />
      <a
        class="UiQuantity__btn UiQuantity__btn--plus shopUiQuantity__btn"
        @click.prevent="addCount({ maxCount: selectedSpec.Stock, limit: itemDatas.Limit })"
      >
        ＋
      </a>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'ProductCounter',
  computed: {
    ...mapState('shopContent', ['itemDatas', 'selectedSpec', 'counter']),
  },
  methods: {
    ...mapMutations('shopContent', ['addCount', 'reduceCount']),
  },
};
</script>
